<template>
  <div>
    <vxe-card>
      <template #title>
        <vxe-button content="button.return" icon="vxe-icon-arrows-left" mode="text" status="primary" @click="back"/>
      </template>
      <template #extra>
        <vxe-button content="button.save" icon="vxe-icon-save" mode="text" status="primary" @click="save"/>
      </template>
      <a-form-model :colon="false" :form="form" :label-col="labelCol" :model="role" :rules="rules" :wrapper-col="wrapperCol">
        <a-row style="margin-left: -2%;margin-right: 2%">
          <a-col :span="6">
            <a-form-model-item :label="$t('business.label.roleNo')">
              <vxe-input v-model="role.no" style="width: 100%"/>
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item :label="$t('business.label.roleName')">
              <vxe-input v-model="role.name" style="width: 100%"/>
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item :label="$t('business.label.available')" :wrapper-col="labelCol">
              <vxe-switch v-model="role.available"/>
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
    </vxe-card>
    <vxe-card>
      <template #title>
        <vxe-button content="business.label.roleAuthority" mode="text" status="primary"/>
      </template>
      <vxe-tree :check-node-keys.sync="checkNodeKeys" v-bind="treeOptions"/>
    </vxe-card>
  </div>
</template>

<script>
import { findAll, findOne, save } from '@/api/Api'
import { Role } from '@/api/dto/admin/Role'
import Vue from 'vue'
import { ENTERPRISE } from '@/store/mutation-types'
import InventoryModal from '@/views/modal/InventoryModal.vue'

export default {
  name: 'MenuOfRole',
  components: { InventoryModal },
  data() {
    const treeOptions = {
      transform: true,
      showCheckbox: true,
      checkboxConfig: {
        highlight: true
      },
      nodeConfig: {
        isHover: true
      },
      data: []
    }
    return {
      treeOptions,
      form: this.$form.createForm(this),
      enterprise: Vue.ls.get(ENTERPRISE),
      role: new Role(),
      loading: false,
      checkNodeKeys: [],
      labelCol: { span: 8 },
      wrapperCol: { span: 16 },
      rules: {
        no: [{ required: true, message: this.$t('message.canNotBeEmpty') }],
        name: [{ required: true, message: this.$t('message.canNotBeEmpty') }]
      }
    }
  },
  created() {
    this.loading = true
    findAll('menuFactory', { available: true }).then(res => {
      this.treeOptions.data = res.result.map(item => {
        return { title: item.name, id: item.id, parentId: item.parent?.id }
      })
    }).finally(() => this.loading = false)
  },
  methods: {
    back() {
      this.$emit('back')
    },
    refresh(args) {
      this.checkNodeKeys = []
      this.loading = true
      findOne('roleFactory', args).then(res => {
        if (res.success) {
          this.role = new Role(res.result)
          this.checkNodeKeys = res.result.menus.filter(item => item.leaf).map(item => item.id)
        }
      }).finally(() => this.loading = false)
    },
    add() {
      this.role = new Role()
      this.checkNodeKeys = []
    },
    save() {
      this.form.validateFields((err) => {
        if (!err) {
          this.loading = true
          const role = this.role.toJSONObject()
          role.enterprise = this.enterprise
          role.menus = this.checkNodeKeys.map(item => {
            return { id: item }
          })
          save('rolePersister', role).then(res => {
            if (res.success) {
              this.role = new Role(res.result)
              this.checkNodeKeys = res.result.menus.filter(item => item.leaf).map(item => item.id)
              this.$message.success(this.$t('message.saveSuccess'))
            }
          }).finally(() => this.loading = false)
        }
      })
    }
  }
}
</script>